import React, { useState, useEffect, Component } from 'react';
import logo from '../images/newlogo.jpg'
import { CookiesProvider, useCookies } from "react-cookie";

const StreamerLayout = ({ children }) => {
    const [cookies, setCookie, removeCookie] = useCookies(['boltAppTheme']);

    const handleThemeChange = () => {

        if (cookies.boltAppTheme === "dark") {

            removeCookie("boltAppTheme");
            setCookie("boltAppTheme", 'light', { path: "/" });
        } else if (cookies.boltAppTheme === "light") {
            removeCookie("boltAppTheme");
            setCookie("boltAppTheme", 'dark', { path: "/" });
        }
        else {
            setCookie("boltAppTheme", 'dark', { path: "/" });
        }
    }

    useEffect(() => {
        if (cookies === null || cookies.boltAppTheme === null || cookies.boltAppTheme === undefined) {
            setCookie("boltAppTheme", 'dark', { path: "/" });
        }
    }, []);

    

    return (
        <CookiesProvider>
            <div id="boltTheme" className={cookies.boltAppTheme === "light" ? "ltr light-theme bg-custom-light" : "ltr light-theme bg-custom-dark"}>
                <div className="horizontalMenucontainer">
                    <div className="horizontalMenucontainer">
                        <div className="page">

                            <div className="main-content pt-0 hor-content d-flex flex-1 flex-column">
                                <div className="container-sm">
                                    <div className="row pd-t-15 pd-b-10 pd-fs-mode tx-gray-500 streamer-bar">
                                        <div className="col-10">
                                            {/*<h3 className="tx-20 custom-title streamer-card-text2">Cardamom eAuction - Live</h3>*/}
                                        </div>
                                        {/*<div className="col-1">*/}
                                        {/*    <div className="header-element header-theme-mode mg-t-4">*/}
                                        {/*        <a onClick={handleThemeChange} className="header-link layout-setting pointer">*/}
                                        {/*            {*/}
                                        {/*                cookies.boltAppTheme === "light" ? <span className="">*/}
                                        {/*                    <i className="fe fe-moon header-link-icon lh-2"></i>*/}
                                        {/*                </span> : <span className="">*/}
                                        {/*                    <i className="fe fe-sun header-link-icon lh-2"></i>*/}
                                        {/*                </span>*/}
                                        {/*            }*/}
                                        {/*        </a>*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-1 ">*/}
                                        {/*    <img src={logo} className="header-brand-img desktop-logo " style={{ position: "absolute", right: '27px' }} alt="logo" />*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                                <div className="main-container d-flex flex-1 ">
                                    {children}
                                </div>
                                {/*<div className="main-container container-sm text-end">*/}
                                {/*    <h6 className="tx-gray-400 design-footer" >DESIGNED AND DEVELOPED BY BOLTWARE | www.boltware.in</h6>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CookiesProvider>
    );
}

export default StreamerLayout;